class NetworkInfoModel {
  constructor({
    downlink_speed = null,
    downlink_speed_max = null,
    cellular_generation = null,
    network_state_type = null,
    save_data_mode = null,
  } = {}) {
    this.downlink_speed = downlink_speed;
    this.downlink_speed_max = downlink_speed_max;
    this.cellular_generation = cellular_generation;
    this.network_state_type = network_state_type;
    this.save_data_mode = save_data_mode;
  }
  json() {
    return {
      cellular_generation: this.cellular_generation,
      downlink_speed: this.downlink_speed,
      downlink_speed_max: this.downlink_speed_max,
      network_state_type: this.network_state_type,
      save_data_mode: this.save_data_mode,
    };
  }
}

module.exports = NetworkInfoModel;
